import React from "react";
import "./WeatherDetails.css";
import windIcon from "./Images/wind-icon.png"; // Import wind-icon.png
import humidityIcon from "./Images/humidity-icon.png"; // Import humidity-icon.png
import precipitationIcon from "./Images/precipitation-icon.png"; // Import precipitation-icon.png

export default function WeatherDetails(props){
    return(
        <div className="WeatherDetails">
            <div className="row pt-1 ">
                <div className="col p-0">
                    <div className="">
                        <div className="card-body">
                          <img src={windIcon} alt="wind-icon" className="card-img"/>
                            <p className="temp-forecast">Wind: {props.windSpeed} km/h</p>
                        </div>
                    </div>
                </div>
                <div className="col p-0">
                    <div className="detail-card">
                        <div className="card-body">
                          <img src={humidityIcon} alt="humidity-icon" className="card-img"/>
                            <p className="temp-forecast"> Precipitation: {props.precipitation}%</p>
                        </div>
                    </div>
                </div>
                <div className="col p-0">
                    <div>
                        <div className="card-body">
                          <img src={precipitationIcon} alt="precipitation-icon" className="card-img" />
                            <p className="temp-forecast">Humidity: {props.humidity}%</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}